/* global Drupal, once */

import Collapse from 'bootstrap/js/dist/collapse';

/**
 * Focus the search field when the search modal opens.
 */
Drupal.behaviors.admnSearchOverlay = {
  attach(context) {
    for (const overlay of once('admn-search-overlay', '#SearchOverlay', context)) {
      overlay.addEventListener('show.bs.modal', () => {
        const collapse = document.querySelector('.page > nav.navbar .navbar-collapse.show');
        if (collapse) {
          Collapse.getOrCreateInstance(collapse).hide();
        }
      });

      overlay.addEventListener('shown.bs.modal', () => {
        const searchInput = overlay.querySelector('input[type="search"], .form-autocomplete');
        if (searchInput) {
          searchInput.focus();
        }
      });
    }
  },
};
